import { toast } from "react-toastify";
import store, { ContractAction, userAction } from "@/Redux/store";
import { EnvKey } from "./const";
import jsonwebtoken from "jsonwebtoken";
import { api } from "./Axios";

export const FetchUserData = async (id, SetLoading, setData) => {
  SetLoading(true);
  try {
    const response = await api.get(`/users`);
    if (response.status === 200 && response.data) {
      if (setData) {
        setData(response.data);
      }

      store.dispatch(userAction.update({ key: "id", val: response.data.id }));
      store.dispatch(
        userAction.update({
          key: "activationStatus",
          val: response.data.activationStatus,
        })
      );
      store.dispatch(
        userAction.update({ key: "avatar", val: response.data.avatar })
      );
      store.dispatch(
        userAction.update({ key: "email", val: response.data.email })
      );
      store.dispatch(
        userAction.update({ key: "phone", val: response.data.phone })
      );
      store.dispatch(
        userAction.update({
          key: "secondPhone",
          val: response.data.secondPhone,
        })
      );
      store.dispatch(
        userAction.update({
          key: "isEligible",
          val: response.data.isEligible,
        })
      );
      store.dispatch(
        userAction.update({
          key: "name",
          val: response.data.name,
        })
      );
      store.dispatch(
        userAction.update({
          key: "nationalId",
          val: response.data.nationalId,
        })
      );
      store.dispatch(
        userAction.update({
          key: "refContact",
          val: response.data.refContact,
        })
      );
      SetLoading(false);
    }
  } catch (error) {
    SetLoading(false);
  }
};
export const FetchUserContract = async (
  id,
  SetLoading,
  SetContractData,
  setErrMsg,
  t
) => {
  try {
    SetLoading(true);
    setErrMsg("");
    const ConREs = await api.post(`/contracts/active`);
    if (ConREs.status === 200 && ConREs.data) {
      SetContractData(ConREs.data);
      store.dispatch(
        ContractAction.update({ key: "Details", val: ConREs.data })
      );
      SetLoading(false);
    }    
    if(ConREs.data.length<=0)
    {      
    setErrMsg(t.user_installements.PreviousDealing.nodataerr);
    }
  } catch (error) {
    setErrMsg(t.user_installements.PreviousDealing.nodataerr);
    SetLoading(false);
  }
};

export const Update = async (userData, Data, t, SetSaveLoading) => {
  try {
    SetSaveLoading(true);

    const addCountryCode = (phone) => {
      if (!phone) return "";
      return phone.startsWith("+2") ? phone : `+2${phone}`;
    };

    const normalizePhone = (phone) =>
      phone && phone.trim() !== "" ? addCountryCode(phone) : "";

    const noChanges =
      userData.name === Data.name &&
      userData.email === Data.email &&
      normalizePhone(userData.secondPhone) === normalizePhone(Data.secondPhone) &&
      normalizePhone(userData.phone) === normalizePhone(Data.phone) &&
      (userData.refContact?.name || "") === (Data.refContact?.name || "") &&
      normalizePhone(userData.refContact?.phone) === normalizePhone(Data.refContact?.phone);

    if (noChanges) {
      SetSaveLoading(false);
      toast.success(
        t === "ar" ? "لا يوجد بيانات جديده لحفظها" : "Data not changed",
        {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
      return;
    }

    const SessionData = jsonwebtoken.verify(
      localStorage.getItem("UT_UI"),
      EnvKey.secretKey
    );
    const UserID = SessionData.id;

    const body = {
      name: userData.name || Data.name,
      email: userData.email || Data.email,
      phone: normalizePhone(userData.phone || Data.phone),
      secondPhone:
        userData.secondPhone?.trim() === ""
          ? null
          : normalizePhone(userData.secondPhone),
      refContact:
        userData.refContact &&
        (userData.refContact.name?.trim() || userData.refContact.phone?.trim())
          ? {
              name: userData.refContact.name || "",
              phone: normalizePhone(userData.refContact.phone),
            }
          : {},
    };

    store.dispatch(userAction.update({ key: "name", val: body.name }));
    store.dispatch(userAction.update({ key: "email", val: body.email }));
    store.dispatch(userAction.update({ key: "phone", val: body.phone }));
    store.dispatch(userAction.update({ key: "secondPhone", val: body.secondPhone }));
    store.dispatch(userAction.update({ key: "refContact", val: body.refContact }));

    const response = await api.put(`users/${UserID}`, body);

    if (response.data.isSuccessful) {
      SetSaveLoading(false);
      toast.success(
        t === "ar" ? "تم التحديث بنجاح" : response.data.message,
        {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
    }
  } catch (error) {
    SetSaveLoading(false);
    toast.error(
      error?.response?.data?.message || "حدث خطأ أثناء التحديث",
      {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      }
    );
  }
};
